const state = {
  contractVendors: [],
  openVendors: [],
  openVehicles: [],
  isContractLoading: false,
  isMatrixLoading: false,
  isPaginating: false,
};

export default state;
